import { useEffect, useState } from 'react';
import './ChallengesForm.scss'
import api from '../../js/api';
import Modal from '../../components/Modal/Modal';
import { isMobile } from '../../js/utils';
import Button from '../../components/Button/Button';

export default function Challenges() {

    const [challenges, setChallenges] = useState([]);

    useEffect(() => {
        api.get('/bingo/challenges', { silent: true }).then((r) => {
            if (r.error) {
                console.error(r.error);
                return;
            }
            setChallenges(r);
            console.log(r);
        })
    }, []);

    const challenge_td = (challenge) => {
        const delete_button = (
            <Button text="Delete" class_="border border-radius"  onClick={async () => {
                const r = await api.delete('/bingo/challenges/' + challenge.id);
                if (r.error)
                    return;
                alert('Challenge deleted successfully!');
                window.location.reload();
            }}></Button>
        );
        const more_button = (
            <Modal text="More data">
                <h3>Challenge details</h3>
                <br />
                <br />
                {console.log(challenge)}
                <p><b>Challenge id: </b>{challenge.id}</p>
                <br />
                {isMobile() ? (<><p><b>Difficulty</b>: {challenge.difficulty}</p><br/></>) : null}
                {isMobile() ? (<><p><b>Created by</b>: {challenge.user_login}</p><br/></>) : null}
                <p><b>Category: </b>{challenge.category}</p>
                <br />
                <p><b>Active: </b>{challenge.active ? 'true' : 'false'}</p>
                <br />
                <p><b>Image required: </b>{challenge.image_required ? 'true' : 'false'}</p>
                
            </Modal>
        )
        return (
            <>
                <td>{challenge.title}</td>
                <td>{challenge.description}</td>
                <td className='hide-mobile'>{challenge.difficulty}</td>
                <td className='hide-mobile'>{challenge.user_login}</td>
                <td>
                    <div className='flex gap flex-center'>
                        {more_button}
                        {delete_button}
                    </div>
                </td>
            </>
        );
    }

    return (
        <div id="challenges">
            <div className='centered-container'>
                <br />
                <h1>Challenges</h1>
                <br />
                <a href="/bingo/challenges/form">Create Challenge</a>
                <br />
                <br />
                <p>List of all challenges</p>
                <br />
                {challenges.length > 0 ? (
                    <table className='challenges-table'>
                        <tr>
                            <th>Title</th>
                            <th>Description</th>
                            <th className='hide-mobile'>Difficulty</th>
                            <th className='hide-mobile'>Created By</th>
                            <th>Actions</th>
                        </tr>
                        {challenges.map((challenge, index) => (
                            <tr key={index}>
                                {challenge_td(challenge)}
                            </tr>
                        ))}
                    </table>
                ) : (
                    <p>No challenges found.</p>
                )}
            </div>
        </div>
    );
}